module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-path-one-71a17252a2dd37203ffe708a37270a1e.png";